const o = /* @__PURE__ */ Symbol();
export {
  o as configProviderContextKey
};
